import script from "./ShowTitle.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ShowTitle.vue?vue&type=script&lang=js"
export * from "./ShowTitle.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ShowTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/show-page/ShowTitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "aa1d14b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('aa1d14b8', __exports__)) {
    api.reload('aa1d14b8', __exports__)
  }
  
}


export default __exports__